import styles from "./page-container-inner.module.css"

// Inner wrapper for non-homepages which contains standardized inset padding
export function PageContainerInner(props: React.ComponentProps<"div">) {
  return (
    <div className={`animation-liftToReveal ${styles["container"]}`} {...props}>
      {props.children}
    </div>
  )
}
